import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";

import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../AppContext";
import { getDocDataById, getDocDataByRef } from "../../models/DataFunctions";
import { Loading } from "../../pages/Loading";
import NotFound from "../../pages/NotFound";
import Attestations from "../../pages/attestations/Attestations";

import Account from "../../pages/parameters/Account";
import Organisation from "../../pages/parameters/Organisation";

import Xmls from "../../pages/attestations/Xmls";
import RTB from "../../pages/parameters/RTB";
import Facturation from "../../pages/parameters/Facturation";
import ATH from "../../pages/parameters/ATH";
import Partners from "../../pages/Partners";
import Home from "../../pages/Home";

type OldRoutesProps = {
  navigateWorkspace: any;
  actualpage: any;

  userData: any;
  orgData: any;
  handleLoginAs: any;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
  setShowProtocole?: (page: number) => void; // Optional prop to control protocol visibility
};

const OldRoutes = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,
  handleLoginAs,
  handleClickVariant,
  setShowProtocole,
}: OldRoutesProps) => {
  const location = useLocation();

  const navigate = useNavigate(); // Hook to handle navigation
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  if (loading) {
    return (
      <div className="h-screen flex flex-col gap-2 bg-white fixed w-screen items-center justify-center">
        <Loading></Loading>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full ">
      {<div className="mt-6"></div>}
      <Routes>
        <Route
          path="/home"
          element={
            <Home
              userData={userData}
              orgData={orgData}
              setCanFetchFolders={() => {}}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/xmls"
          element={
            <Xmls
              userData={userData}
              orgData={orgData}
              setCanFetchFolders={() => {}}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/attestations"
          element={
            <Attestations
              userData={userData}
              orgData={orgData}
              setCanFetchFolders={() => {}}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />{" "}
        <Route
          path="/partners"
          element={
            <Partners
              userData={userData}
              orgData={orgData}
              setCanFetchFolders={() => {}}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/account"
          element={
            <Account
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/organisation"
          element={
            <Organisation
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/rtb"
          element={
            <RTB
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/ath"
          element={
            <ATH
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/facturation"
          element={
            <Facturation
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="*"
          element={<NotFound navigateWorkspace={navigateWorkspace} />}
        />
      </Routes>
    </div>
  );
};

export default OldRoutes;
